<template>
  <div class="analysis">
    <div class="header">
      <div class="container clearfix">
        <div class="logo-box">
          <router-link to="/"></router-link>
          <!--          <span> · 交易分析神器</span>-->
        </div>
        <div class="right-box">
          <router-link to="/" title="首页"><i class="el-icon-s-home"></i></router-link>
          <UserMenu/>
        </div>
        <div class="type-btn-box">
          <el-button-group>
            <el-button :class="analysisType === 'single' ? 'selected' : ''"
                       @click="openAccountDialog('single')">单账户分析
            </el-button>
            <el-button :class="analysisType === 'multiple' ? 'selected' : ''"
                       @click="openAccountDialog('multiple')">多账户分析
            </el-button>
            <!--              <el-button :class="analysisType === 'group' ? 'selected' : ''"-->
            <!--                         @click="openAccountDialog('group')">分组分析-->
            <!--              </el-button>-->
          </el-button-group>
        </div>
        <div class="change-account-box">
          <el-popover
              placement="bottom"
              title="已选择账户"
              width="200"
              trigger="hover"
          >
            <template v-if="accounts.length <= 1">
              <div v-for="item in accounts" :key="item.id">
                <p v-show="curAccountId.indexOf(item.id) !== -1">{{ item.nickname }}
                  ({{ item.account_code }})</p>
              </div>
            </template>
            <el-button slot="reference" class="accout-button" type="text" icon="el-icon-s-platform">
              {{ curAccountName }}{{ curAccount }}
            </el-button>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="analysis-main container">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-card class="menu-card">
            <el-menu :default-active="activeName" :unique-opened="true" :router="true">
              <el-submenu :index="index.toString()" v-for="(menu, index) in menus" :key="index"
                          v-show="analysisType === 'single' || (analysisType === 'multiple' && menu.supportMulti)">
                <template slot="title">
                  <i :class="['left_icon', menu.icon]"></i>
                  <span>{{ menu.name }}</span>
                  <i class="right_icon dowm_icon"></i>
                </template>
                <el-menu-item-group>
                  <el-menu-item v-for="item in menu.children" :key="item.path" :index="item.path"
                                v-show="analysisType === 'single' || (analysisType === 'multiple' && item.supportMulti)">
                    {{ item.name }}
                  </el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </el-menu>
          </el-card>
        </el-col>
        <el-col :span="19" class="right-box">
          <router-view/>
        </el-col>
      </el-row>
    </div>
    <div class="footer">
      <p>© 2019 大盘手网络科技 <a class="icp" href="http://beian.miit.gov.cn">渝ICP备19015980号-1</a></p>
    </div>
    <account-selector :visible.sync="accountDialogVisible" :cur-account-ids="accountSelectorDefaultId" :accounts="accounts" :groups="groups"
                      :type="accountSelectorType" v-on:change="handleOk"></account-selector>
  </div>
</template>

<script>
import UserMenu from "../components/UserMenu";
import AccountSelector from "@/components/AccountSelector.vue";
import {mapActions} from "vuex";

export default {
  name: "Analysis",
  components: {
    AccountSelector,
    UserMenu
  },
  data() {
    return {
      accountSelectorType: '',
      visible: false,
      accountSearchWord: '',
      accountSelectorDefaultId: [],
      accountDialogVisible: false,
      menus: [
        {
          name: '综合统计',
          icon: 'stat_icon',
          supportMulti: true,
          children: [
            {name: '统计报表', path: 'report', supportMulti: true}
          ]
        },
        {
          name: '收益分析',
          icon: 'income_icon',
          supportMulti: true,
          children: [
            {name: '累计净值', path: 'netValue', supportMulti: true},
            {name: '动态回撤', path: 'dynamicRetreat', supportMulti: true},
            {name: '历史权益', path: 'equities', supportMulti: true},
            {name: '费用返还', path: 'feeRefund', supportMulti: true},
            {name: '盈亏曲线', path: 'profitCurve', supportMulti: true},
            // {name: '收益率分布', path: 'yieldDist', supportMulti: true},
            {name: '夏普比率', path: 'sharp', supportMulti: true},
            // {name: '收益回撤比', path: 'returnRatio', supportMulti: false},
            {name: '每周盈亏', path: 'weekProfit', supportMulti: true},
            {name: '每月盈亏', path: 'monthProfit', supportMulti: true},
            {name: '盈亏TOP10', path: 'topTen', supportMulti: true}
          ]
        },
        {
          name: '交易特征',
          icon: 'trans_icon',
          supportMulti: true,
          children: [
            {name: '持仓周期', path: 'takeCycle', supportMulti: true},
            {name: '周期盈亏', path: 'cycleProfit', supportMulti: true},
            {name: '周期胜率', path: 'cycleOdds', supportMulti: true},
            {name: '成交结构', path: 'tradeStruct', supportMulti: true},
            {name: '品种盈亏', path: 'varietyProfit', supportMulti: true},
            {name: '品种胜率', path: 'varietyOdds', supportMulti: true},
            {name: '多空仓位', path: 'longShort', supportMulti: true},
            {name: '多单盈亏', path: 'longProfit', supportMulti: false},
            {name: '空单盈亏', path: 'shortProfit', supportMulti: false},
            {name: '隔夜仓位', path: 'overnight', supportMulti: false},
            {name: '单边敞口', path: 'exposure', supportMulti: false},
            {name: '累计出入金', path: 'fundChange', supportMulti: true},
          ]
        },
        {
          name: '品种分析',
          icon: 'analysis_icon',
          supportMulti: true,
          children: [
            {name: '盈亏曲线', path: 'singleVariety', supportMulti: true},
            {name: '每周盈亏', path: 'varietyWeekProfit', supportMulti: true},
            {name: '每月盈亏', path: 'varietyMonthProfit', supportMulti: true}
          ]
        },
        {
          name: '原始数据',
          icon: 'origin_icon',
          supportMulti: false,
          children: [
            {name: '逐日结算', path: 'dailySett', supportMulti: false},
            {name: '期货成交明细', path: 'tradeDetail', supportMulti: false},
            {name: '期货持仓明细', path: 'takeDetail', supportMulti: false},
            // {name: '持仓汇总', path: 'takeTotal', supportMulti: false}
            {name: '期货持仓汇总', path: 'holdTotal', supportMulti: false},
            {name: '期权成交明细', path: 'optTradeDetail', supportMulti: false},
            {name: '期权持仓明细', path: 'optHoldTotal', supportMulti: false}
          ]
        }
      ],
    };
  },
  computed: {
    activeName: function () {
      return this.$route.name;
    },
    groups: function () {
      return this.$store.state.groups;
    },
    accounts: function () {
      return this.$store.state.accounts;
    },
    analysisType: function () {
      return this.$store.state.analysisType;
    },
    curAccountId: function () {
      return this.$store.state.curAccountId;
    },
    curAccount: function () {
      if (this.$store.state.curAccountId.length > 1) {
        return '';
      }
      for (let item in this.accounts) {
        if (this.accounts[item].id === this.$store.state.curAccountId[0]) {
          return '(' + this.accounts[item].account_code + ')';
        }
      }
      return '';
    },
    curAccountName: function () {
      if (this.$store.state.curAccountId.length > 1) {
        return '已选择多账号';
      }
      for (let item in this.accounts) {
        if (this.accounts[item].id === this.$store.state.curAccountId[0]) {
          return this.accounts[item].nickname;
        }
      }
      return '';
    }
  },
  methods: {
    ...mapActions(['fetchAllAccounts', 'fetchAllGroups']),
    async openAccountDialog(type) {
      // 获取所有账号
      // await this.fetchAllAccounts();

      // 获取所有分组
      // await this.fetchAllGroups();

      this.accountSelectorDefaultId = [...this.curAccountId];

      if (this.analysisType !== type) {
        this.accountSelectorDefaultId = [];
      }

      this.accountSelectorType = type;
      this.accountDialogVisible = true;
    },
    handleOk(accountIds) {
      if (this.analysisType !== this.accountSelectorType) {
        this.$router.push({path: '/analysis/netValue'});
      }
      this.$store.commit('SET_ANALYSIS_TYPE', this.accountSelectorType);
      this.$store.commit('SET_CUR_ACCOUNT_ID', accountIds);
      this.accountDialogVisible = false;
    }
  },
  beforeCreate() {
    if (this.$store.state.accounts.length === 0) {
      this.$message({
        message: '请先添加期货监控中心账户或等待数据更新',
        type: 'warning'
      });
      this.$router.push({name: 'Account'})
    } else if (this.$store.state.curAccountId.length === 0) {
      let curAccount = this.$store.state.accounts[0];
      this.$store.commit('SET_CUR_ACCOUNT_ID', [curAccount.id]);
    }
  }
}
</script>

<style lang="scss">
.analysis {
  .mt5 {
    margin-top: 5px;
  }

  .mt20 {
    margin-top: 20px;
  }

  .header {
    .container {
      position: relative;
    }

    .logo-box {
      float: left;
      display: flex;
      align-items: center;
      height: 60px;
      text-align: left;

      a {
        display: block;
        width: 143px;
        height: 50px;
        background-image: url("../assets/qwh_only_logo.png");
        background-size: contain;
        background-repeat: no-repeat;
      }

      span {
        line-height: 45px;
        margin-left: 10px;
        font-size: 14px;
      }
    }

    .right-box {
      float: right;
      display: flex;
      align-items: center;

      i {
        font-size: 26px;
        color: #666666;
        line-height: 60px;
        margin-right: 20px;
      }
    }

    .change-account-box {
      float: right;
      margin-right: 30px;
      color: #666666;

      .accout-button {
        margin-left: 20px;
        padding: 0;
        border: 0;
        color: #666666;
        font-size: 16px;
        max-width: 244px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        &:hover, &:focus {
          background: none;
          color: #666666;
        }
      }

      i {
        line-height: 60px;
      }
    }

    /* 单账户分析 / 多账户分析，居中于导航栏 */
    .type-btn-box {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: left;
      color: #666666;

      .el-button {
        &:hover, &:focus {
          background: none;
          color: #DD593B;
          border-color: #DCDFE6;
        }

        &.selected {
          transition: none;
          background-image: url("../assets/selected_bg.png");
          background-position: right bottom;
          background-size: 25px 25px;
          background-repeat: no-repeat;
          color: #DD593B;
        }
      }
    }

    .cur-account-info {
      font-size: 14px;
      margin-right: 20px;
    }
  }

  .analysis-main {
    margin: 20px auto;
    min-height: 830px;

    .right-box {
      margin-bottom: 80px;
    }

    .menu-card {
      .el-menu {
        border: 0;

        .el-submenu {
          .el-submenu__title {
            margin-bottom: 10px;
            padding: 0;
            display: flex;
            align-items: center;
            font-size: 16px;

            .left_icon {
              width: 24px;
              height: 24px;

              &.stat_icon {
                background-image: url("../assets/analysis/stat_icon.png");
                background-size: 24px 24px;
              }

              &.income_icon {
                background-image: url("../assets/analysis/income_icon.png");
                background-size: 24px 24px;
              }

              &.trans_icon {
                background-image: url("../assets/analysis/trans_icon.png");
                background-size: 24px 24px;
              }

              &.origin_icon {
                background-image: url("../assets/analysis/origin_icon.png");
                background-size: 24px 24px;
              }

              &.analysis_icon {
                background-image: url("../assets/analysis/analysis_icon.png");
                background-size: 24px 24px;
              }
            }

            > span {
              height: 24px;
              font-size: 18px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 24px;
              color: #333333;
              margin: 0 15px;

              &.active {
                color: #3598DB;
              }
            }

            .right_icon {
              width: 12px;
              height: 8px;

              &.dowm_icon {
                background-image: url("../assets/analysis/down_arrow_icon.png");
                background-size: 12px 8px;
              }
            }

            .el-submenu__icon-arrow {
              display: none;
            }
          }

          /*&.active {*/
          /*  .el-submenu__title {*/
          /*    margin-bottom: 10px;*/
          /*    background: #FFFFFF;*/
          /*    box-shadow: 0px 4px 6px rgba(53, 152, 219, 0.3);*/
          /*    color: #3598DB;*/
          /*    border-radius: 5px;*/
          /*  }*/
          /*}*/
          .el-menu-item-group {
            .el-menu-item-group__title {
              display: none;
            }

            .el-menu-item {
              height: 44px;
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              line-height: 44px;
            }
          }

          &.is-opened {
            .el-submenu__title {
              margin-bottom: 10px;
              background: #FFFFFF;
              box-shadow: 0px 4px 6px rgba(53, 152, 219, 0.3);
              color: #3598DB;
              border-radius: 5px;

              .left_icon {
                &.stat_icon {
                  background-image: url("../assets/analysis/stat_active_icon.png");
                  background-size: 24px 24px;
                }

                &.income_icon {
                  background-image: url("../assets/analysis/income_active_icon.png");
                  background-size: 24px 24px;
                }

                &.trans_icon {
                  background-image: url("../assets/analysis/trans_active_icon.png");
                  background-size: 24px 24px;
                }

                &.origin_icon {
                  background-image: url("../assets/analysis/origin_active_icon.png");
                  background-size: 24px 24px;
                }

                &.analysis_icon {
                  background-image: url("../assets/analysis/analysis_active_icon.png");
                  background-size: 24px 24px;
                }
              }

              .right_icon {
                /*transform: rotate(180deg);*/
                &.dowm_icon {
                  background-image: url("../assets/analysis/up_arrow_icon.png");
                  background-size: 12px 8px;
                }
              }

              > span {
                color: #3598DB;
              }
            }

          }
        }

        .kine-item {
          text-align: left;

          .left_icon {
            width: 24px;
            height: 24px;

            &.kline_icon {
              background-image: url("../assets/analysis/kline_icon.png");
              background-size: 24px 24px;
              display: inline-block;
            }
          }

          span {
            height: 24px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            line-height: 24px;
            color: #333333;
            margin: 0 15px;
          }

          &.is-active {
            .left_icon.kline_icon {
              background-image: url("../assets/analysis/kline_active_icon.png");
            }

            span {
              color: #409EFF;
            }
          }
        }

      }
    }

    .el-card {
      .chart {
        margin: 50px 0;
      }
    }

    .blackboard {
      box-sizing: border-box;
      height: 220px;
      width: 100%;
      background: url("../assets/blackboard.png");
      background-size: 100% 100%;
      color: #FFFFFF;
      padding: 10px 210px 20px 25px;
      text-align: left;

      p {
        font-size: 14px;
        margin: 10px 0;
        color: #f5f5f5;
      }

      .star-level {
        line-height: 24px;

        .el-rate {
          display: inline-block;

          i {
            font-size: 24px;
          }
        }
      }
    }
  }

  .footer {
    width: 100%;
    position: fixed;
    bottom: 0;
    z-index: 1000;
  }

}

</style>
